export class CampoExtraRequest  {
    valor:string;
    descValor:string;
    bubCatCamposConfigIdCampoPk:number;
    idCampoExtraPk:number;
    idBinFk:number;
    bubBinesIdBinPk:number;
    descripcionCampo:string;
    estatus:number;
} 